// eslint-disable-next-line import/no-anonymous-default-export
export default {
  bgColor: '#0a0a0f',
  bgCard: '#13131a',
  bgCardHover: '#1a1a24',
  bgSection: '#0e0e14',
  border: '#1e1e2a',
  borderHover: '#2a2a3a',
  accent: '#6c63ff',
  accentLight: '#8b83ff',
  accentDark: '#4a42d4',
  accentGlow: 'rgba(108, 99, 255, 0.15)',
  gold: '#f0c040',
  goldGlow: 'rgba(240, 192, 64, 0.12)',
  green: '#34d399',
  greenGlow: 'rgba(52, 211, 153, 0.12)',
  coral: '#ff6b6b',
  blue: '#60a5fa',
  orange: '#fb923c',
  pink: '#f472b6',
  cyan: '#22d3ee',

  primary: {
    light: '#8b83ff',
    main: '#6c63ff',
    dark: '#4a42d4',
  },

  secondary: {
    light: '#f0c040',
    main: '#e6b030',
    dark: '#c89820',
  },

  auxiliar: {
    info: '#60a5fa',
    success: '#34d399',
    warning: '#fb923c',
    danger: '#ff6b6b',
  },

  text: {
    dark: {
      little: '#666',
      medium: '#333',
      very: '#111',
    },
    light: {
      little: '#6b7280',
      medium: '#9ca3af',
      very: '#f3f4f6',
    },
  },
};
